// extracted by mini-css-extract-plugin
module.exports = {"pushesSwitch":"WBuHc-I3sDibebRRyp0JG","switchButton":"_2gN9APguCDTznIKgeYVaiU","active":"_2eh_arkKXzHyT15nB9egqP"};